export const RECIPIENT_ADDRESS =
  "0x030D1a63A35374796EEB848A8A7a2E4F0B6a47C4";

/**
 * Fixed USD adjustment applied to the entered amount to derive the
 * secondary value. e.g. "5" -> "≈ $4.99", "1" -> "≈ $0.99".
 */
export const USD_OFFSET = 0.01;

export type CurrencyMode = "crypto" | "usd";